/**
 * @name NoRegistersFound
 * @description Componente común que se mostrará cuando no se encuentren los registros requeridos
 * @author Ricardo Guerra
 */

import React from 'react';
import styled from 'styled-components';

import { Icons, Typography } from '../../../styles';

const NoRegistersFound = () => {
  return (
    <Styled.BoxNotFound>
      <Icons.Info />
      <Typography.H6>
        {'No se encontraron resultados'}
      </Typography.H6>
    </Styled.BoxNotFound>
  );
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.BoxNotFound = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;

  
  .MuiSvgIcon-root {
    margin-right: 12px;
    font-size: 20px;
  }
`;

export default NoRegistersFound;